import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import FormattedNumber from '/component/base/FormattedNumber';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {MetricsSection} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './RankUpItem.style';
interface RankUpItemProps {
  item: {
    label: string;
    value: number;
    testID: string;
  };
  onPress: () => void;
}

export const RankUpItem: React.FC<RankUpItemProps> = ({
  onPress = noop,
  item: {label, value, testID},
}) => {
  const {tt} = useTranslation('screen.teams.section.coachesToCelebrate.rankUp');

  return (
    <TouchableOpacity
      {...testProperties(testID, true)}
      style={styles.base}
      onPress={onPress}>
      <View style={styles.label}>
        <Text
          testID={MetricsSection.metricTitle}
          useCompetency
          style={styles.text}>
          {label}
        </Text>
        <View style={styles.carrot}>
          <FormattedNumber testID={MetricsSection.metricValue} value={value} />
          <Icon name={'chevron-right'} style={styles.arrowIcon} />
        </View>
      </View>
      <Text
        testID={MetricsSection.metricSubTitle}
        emphasis="standard"
        variant="caption">
        {tt('lastClosePeriod', 'Last Close Period')}
      </Text>
    </TouchableOpacity>
  );
};

export default RankUpItem;
